(() => {
  'use strict';
  const root = document.querySelector('[data-pa-presentment-currency]');
  if (!root || root.dataset.paPresentmentCurrency === 'CAD') return;
  const expected = root.dataset.paPresentmentCurrency;
  const base = new URL(window.Shopify?.routes?.root || '/', location.origin);
  if (base.origin !== location.origin) return;
  const pending = new WeakSet();
  const nativeProducts = new Map();
  async function json(path) {
    const url = new URL(path, base);
    if (url.origin !== location.origin) throw new Error('Unexpected origin');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Native preview unavailable');
    return response.json();
  }
  function note(form, text) {
    let element = form.querySelector('[data-pa-presentment-note]');
    if (!element) {
      element = document.createElement('p');
      element.className = 'draft-note';
      element.dataset.paPresentmentNote = '';
      element.setAttribute('role', 'status');
      form.prepend(element);
    }
    element.textContent = text;
  }
  function fallback(form) {
    form.dataset.paPresentmentState = 'cached-source';
    note(form, 'Preview shows saved CAD source prices. Native ' + expected + ' pricing is not available for this unpublished binding yet.');
  }
  async function hydrate(form) {
    if (pending.has(form) || form.dataset.paPresentmentState === 'native') return;
    pending.add(form);
    try {
      if (expected !== 'USD') throw new Error('Unsupported display parser');
      const handle = form.dataset.paProductHandle;
      if (!handle || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) throw new Error('Verified handle missing');
      const cart = await json('cart.js');
      if (cart.currency !== expected) throw new Error('Context mismatch');
      if (!nativeProducts.has(handle)) nativeProducts.set(handle, json('products/' + encodeURIComponent(handle) + '.js'));
      const product = await nativeProducts.get(handle);
      if (product.handle !== handle || !Array.isArray(product.variants)) throw new Error('Product mismatch');
      const select = form.querySelector('select[name="id"]');
      const controls = [...form.querySelectorAll('.pa-story-choices select')];
      if (!select || !controls.length) throw new Error('Choices not initialized');
      const rows = [...select.options];
      const nativeRows = new Map(product.variants.map(variant => [String(variant.id), variant]));
      const updates = rows.map(option => {
        const variant = nativeRows.get(option.value);
        if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0) throw new Error('Incomplete native variants');
        const title = option.textContent.replace(/\s+[\u2014\u2013-]\s+\$.*$/, '').trim();
        if (!Array.isArray(variant.options) || title !== variant.options.join(' / ')) throw new Error('Variant options mismatch');
        return { option, cents: variant.price, title };
      });
      if (nativeRows.size !== rows.length || new Set(rows.map(option => option.value)).size !== rows.length) throw new Error('Variant count mismatch');
      const confirmed = await json('cart.js');
      if (confirmed.currency !== expected || root.dataset.paPresentmentCurrency !== expected) throw new Error('Currency changed');
      const chosen = select.value;
      const choices = controls.map(control => control.value);
      const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      updates.forEach(({ option, cents, title }) => {
        option.dataset.paCadSourceLabel ||= option.textContent;
        option.dataset.priceCents = String(cents);
        option.dataset.currency = expected;
        option.textContent = title + ' — $' + formatter.format(cents / 100) + ' ' + expected;
      });
      controls.forEach((control, index) => { control.value = choices[index]; });
      controls[0].dispatchEvent(new Event('change', { bubbles: true }));
      if (select.value !== chosen) throw new Error('Selection changed');
      form.dataset.paPresentmentState = 'native';
      form.querySelector('[data-pa-presentment-note]')?.remove();
    } catch {
      const select = form.querySelector('select[name="id"]');
      if (select) {
        [...select.options].forEach(option => {
          if (option.dataset.paCadSourceLabel) {
            option.textContent = option.dataset.paCadSourceLabel;
            delete option.dataset.priceCents;
            delete option.dataset.currency;
          }
        });
        form.querySelector('.pa-story-choices select')?.dispatchEvent(new Event('change', { bubbles: true }));
      }
      fallback(form);
    }
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) hydrate(entry.target); });
  });
  root.querySelectorAll('.pa-staged-form').forEach(form => {
    fallback(form);
    observer.observe(form);
  });
})();

